import { withGitpodSize } from "@/assets/icons/utils";
import { TASK_DESCRIPTIONS, TASK_NAME } from "@/routes/ona-onboarding/onboarding-state";
import IconArrowSplit from "central-icons/IconArrowSplit";
import IconCircleDotted from "central-icons/IconCircleDotted";
import IconTestflight from "central-icons/IconTestflight";

export const PREDEFINED_TASKS = [
    {
        taskName: TASK_NAME.automateEnvSetup,
        Icon: withGitpodSize(IconCircleDotted),
        iconColor: "#0048FF",
        iconBackgroundColor: "#CAD7FA",
        title: "Automate env setup",
        description: "Create a fully working dev environment as code configuration.",
        prompt: TASK_DESCRIPTIONS[TASK_NAME.automateEnvSetup].prompt,
    },
    {
        taskName: TASK_NAME.fixBug,
        Icon: withGitpodSize(IconArrowSplit),
        iconColor: "#541500",
        iconBackgroundColor: "#FFDED4",
        title: "Fix a bug",
        description: "Find a bug in the codebase that looks important and fix it.",
        prompt: TASK_DESCRIPTIONS[TASK_NAME.fixBug].prompt,
    },
    {
        taskName: TASK_NAME.boostTestCoverage,
        Icon: withGitpodSize(IconTestflight),
        iconColor: "#9800F0",
        iconBackgroundColor: "#EFD4FF",
        title: "Boost your test coverage",
        description: "Find key areas to cover with new and smarter tests.",
        prompt: TASK_DESCRIPTIONS[TASK_NAME.boostTestCoverage].prompt,
    },
] as const;

export type PredefinedTask = (typeof PREDEFINED_TASKS)[number];

export const PROMPT_TEMPLATE_SIZES = ["sm", "base", "lg"] as const;
